import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { CarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandReviewWithCommentTile } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/BrandReviewWithCommentTile";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackSeoSuppliersPageMostPopularCarouselView } from "@faire/web-api--source/events/seo/view/suppliersPageMostPopularCarousel";
import React from "react";
var MAX_ITEMS_MOBILE = 1;
var MAX_ITEMS_DESKTOP = 3;
export var MostPopularBrandsCarousel = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    var CarouselBaseComponent = CarouselBase;
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onItemClick = _React_useContext.onItemClick, onVisible = _React_useContext.onVisible;
    var isMobile = useViewport().isMobile;
    var renderTile = function(brandReviewTile) {
        return /*#__PURE__*/ _jsx(BrandReviewWithCommentTile, {
            item: brandReviewTile,
            onClick: function(token) {
                if (layoutElement.on_click_event_name) {
                    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(layoutElement.on_click_event_name, requestId, token);
                }
            }
        }, brandReviewTile.brand_token);
    };
    var onItemsVisible = function(items) {
        trackSeoSuppliersPageMostPopularCarouselView();
        var itemTokens = items.map(function(item) {
            return item.brand_token;
        }).filter(isNotUndefined);
        if (layoutElement.on_click_event_name) {
            var _itemTokens_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_itemTokens_join = itemTokens === null || itemTokens === void 0 ? void 0 : itemTokens.join(" ")) !== null && _itemTokens_join !== void 0 ? _itemTokens_join : "");
        }
    };
    var getItems = function() {
        return layoutElement.layout_element_data.map(function(elementData) {
            return elementData.brand_review_tile;
        }).filter(isNotUndefined);
    };
    return /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread({
        renderItem: renderTile,
        items: getItems(),
        itemsPerSlide: {
            mobileAndAbove: MAX_ITEMS_MOBILE,
            tabletAndAbove: MAX_ITEMS_DESKTOP
        },
        peekNext: isMobile,
        peekNextPercent: {
            mobileAndAbove: 25,
            tabletAndAbove: 0
        },
        itemGap: 16,
        onItemsVisible: function(items) {
            trackSeoSuppliersPageMostPopularCarouselView();
            onItemsVisible(items);
        }
    }, props));
};
